import config from 'constants/config'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import useFeatureFlag from 'hooks/Experiments/useFeatureFlag'
import { useAppSelector } from 'hooks/reduxHooks'
import { useIsMobileOrTablet } from 'hooks/useIsMobileOrTablet'
import { canAccessStaffChat } from 'tripPlanner/utils/staffChatAccess'

export function canUseTripChatMobile({
  accountEmail,
  isTripChatMobileEnabled,
}: {
  accountEmail?: string
  isTripChatMobileEnabled: boolean
}): boolean {
  return isTripChatMobileEnabled || canAccessStaffChat(accountEmail)
}

export function useCanAccessMobileChat(): boolean {
  const isTripChatMobileEnabled = useFeatureFlag(OptimizelyFeatureFlags.tripChatMobile)
  const accountEmail = useAppSelector(state => state.auth.account.email)

  if (!config.ENABLE_TRIP_PLANNER) {
    return false
  }

  return canUseTripChatMobile({
    accountEmail,
    isTripChatMobileEnabled,
  })
}

/**
 * On LE desktop we always route users to the chat trip planner. Mobile/tablet
 * chat access requires either the mobile chat flag or the staff email allowlist.
 * Brands without trip planner get `false` so consumers hide any trip-planning
 * UI entirely.
 */
export default function useShouldUseChat(): boolean {
  const isMobileOrTablet = useIsMobileOrTablet()
  const canAccessMobileChat = useCanAccessMobileChat()

  if (!config.ENABLE_TRIP_PLANNER) {
    return false
  }

  if (isMobileOrTablet) {
    return canAccessMobileChat
  }

  return true
}
